// dependencies
import React, { useEffect, useState } from 'react'
// import ReactJson from 'react-json-view'

// components
import { BUTTON_THEME, CircularLoader } from '@st-operations/uikit/src/v2/index.js' // Table, Switch
import Header from '_components/header/index.jsx'

//hooks
import { useRetractSidebar } from '_hooks'

// services
import { getEntity } from '_services/appnexus-audiences.js'

// constants
import { ENTITY } from '../constants' // TABLE_COLUMNS_SINGULAR

// styles
import './styles.scss'
import { logErrorAsync } from '../../../lib/utility'

const AppNexusAudience = (props) => {
  const { id } = props.match.params
  const [data, setData] = useState(null)
  // const [isJSONView, setIsJSONView] = useState(false)
  const [lastModified, setLastModified] = useState(null)

  useRetractSidebar()

  const loadData = async () => {
    try {
      const data = await getEntity(ENTITY, id)
      setData(data)
      setLastModified(data.lastModified.toString())
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  useEffect(() => {
    if (!data) {
      loadData()
    }
  }, [data])

  const handleExit = () => props.history.push(`/${ENTITY}`)

  const headerActions = [
    {
      children: 'Exit',
      onClick: handleExit,
      theme: BUTTON_THEME.GHOST,
    },
  ]

  if (!data) {
    return (
      <div className="appnexus-audience__loading">
        <CircularLoader />
      </div>
    )
  }

  return (
    <div id="appnexus-audience-page" className="appnexus-audience">
      <Header actions={headerActions} back={handleExit}>
        <h1 className="appnexus-audience__header-title">{data.shortName}</h1>
      </Header>

      <h2 className="appnexus-audience__title">{data.shortName}</h2>

      <div className="appnexus-audience__list-header">
        <h4>Information</h4>
      </div>
      <dl className="appnexus-audience__list">
        <div className="appnexus-audience__item">
          <dt>AppNexus Id:</dt>
          <dd>{data.id}</dd>
        </div>
        <div className="appnexus-audience__item">
          <dt>State:</dt>
          <dd>{data.state}</dd>
        </div>
        <div className="appnexus-audience__item">
          <dt>Member ID:</dt>
          <dd>{data.memberId}</dd>
        </div>
        <div className="appnexus-audience__item">
          <dt>CPM Rate:</dt>
          <dd>{data.cpmRate}</dd>
        </div>
        <div className="appnexus-audience__item">
          <dt>Last Modified:</dt>
          <dd>{lastModified}</dd>
        </div>
      </dl>

      {/* <div className="appnexus-audience__batches-wrapper">
        <h3 className="appnexus-audience__batches-label">Data Rate Batches</h3>
        <div className="appnexus-audience__json-switch">
          <Switch checked={isJSONView} onChange={() => setIsJSONView((state) => !state)} />
          <span className="appnexus-audience__json-switch-label">JSON View</span>
        </div>
      </div>
      <Choose>
        <When condition={isJSONView}>
          <ReactJson name={false} displayDataTypes={false} src={data.dataRates} />
        </When>
        <Otherwise>
          <Table columns={TABLE_COLUMNS_SINGULAR} data={data.dataRates} />
        </Otherwise>
      </Choose> */}
    </div>
  )
}

export default AppNexusAudience
